import React, { Component } from 'react'
import AddTitleBar from '../../components/titleBar/add_titleBar'
import  EditJobcard  from '../../components/jobcardComponent/editJobcard'

export default class UpdateJobCard extends Component {
    render() {
        return (
            <React.Fragment>
                <EditJobcard {...this.props}/>
            </React.Fragment>
        )
    }
}
